import { Carousel } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .carousel' ) )
     .forEach( carouselNode => new Carousel( carouselNode ) )
